import { render } from "./component-subdivision.vue?vue&type=template&id=6425abd0"
import script from "./component-subdivision.vue?vue&type=script&setup=true&lang=js"
export * from "./component-subdivision.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-subdivision.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6425abd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6425abd0', __exports__)) {
    api.reload('6425abd0', __exports__)
  }
  
  module.hot.accept("./component-subdivision.vue?vue&type=template&id=6425abd0", () => {
    api.rerender('6425abd0', render)
  })

}


export default __exports__